/*
  EBELS CLICK TRACKING
  Publishes named custom events through Shopify's own Web Pixels sandbox
  (window.Shopify.analytics.publishCustomEvent) instead of calling GA4 or
  GTM directly -- so these events automatically respect whatever the
  visitor chose in the Customer Privacy consent banner, same as Shopify's
  built-in commerce events. A Custom Pixel created in Settings > Customer
  events (admin) subscribes to these event names and forwards them to
  GA4 -- see the setup steps for exactly how.

  Two ways an element gets tracked, so most of the theme never needs to
  be touched by hand:

  1. Explicit opt-in -- add data-track-click="event_name" (and optionally
     data-track-label="...") to any element. Used for promo/hero CTAs,
     where the event name and label are meaningful per-block content.
  2. Built-in cases below -- elements that are already reliably
     identifiable by their existing class/attribute (social links,
     collection sort options, the "New Arrivals" pill) are tracked
     automatically, with no extra markup needed.

  Event names published:
  - promo_banner_click   { element: <button/tile label> }
  - social_link_click    { platform: <facebook/instagram/etc> }
  - collection_sort_click{ element: <sort option label> }
*/
(function () {
  function publish(eventName, payload) {
    if (
      typeof window.Shopify === 'undefined' ||
      !window.Shopify.analytics ||
      typeof window.Shopify.analytics.publishCustomEvent !== 'function'
    ) {
      return;
    }
    window.Shopify.analytics.publishCustomEvent(eventName, payload);
  }

  document.addEventListener('click', function (event) {
    var explicit = event.target.closest('[data-track-click]');
    if (explicit) {
      var label = explicit.getAttribute('data-track-label') || explicit.textContent.trim().slice(0, 80);
      publish(explicit.getAttribute('data-track-click'), { element: label });
      return;
    }

    var socialLink = event.target.closest('.list-social__link');
    if (socialLink) {
      var hiddenLabel = socialLink.querySelector('.visually-hidden');
      var platform = hiddenLabel ? hiddenLabel.textContent.trim() : socialLink.href;
      publish('social_link_click', { platform: platform });
      return;
    }

    var sortOption = event.target.closest('[data-sort-option]');
    if (sortOption) {
      publish('collection_sort_click', { element: sortOption.textContent.trim() });
      return;
    }

    var pill = event.target.closest('.ebels-cg__pill');
    if (pill) {
      publish('collection_sort_click', { element: pill.textContent.trim() });
    }
  });
})();
